import { Link, Outlet, useLocation } from "react-router-dom";

import { Button } from "@/components/ui/button";

import { BottomTabBar } from "@/components/karma/BottomTabBar";
import { SiteHeader } from "@/components/layout/SiteHeader";
import { cn } from "@/lib/utils";

function useTitle(pathname: string) {
  if (pathname === "/likes") return "Beğeniler";
  if (pathname === "/messages") return "Mesajlar";
  if (pathname === "/karma/cember") return "Çember";
  if (pathname === "/profile" || pathname.startsWith("/karma/me") || pathname.startsWith("/karma/u/")) {
    return "Profil";
  }
  return "Keşif";
}

export function KarmaLayout() {
  const { pathname } = useLocation();
  const title = useTitle(pathname);

  return (
    <div className="min-h-dvh bg-background">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-hero-glow" />
      <div className="pointer-events-none fixed inset-0 -z-10 bg-grid-fade opacity-[0.35] [background-size:22px_22px]" />

      <div className="hidden md:block">
        <SiteHeader />
      </div>

      <header className="sticky top-0 z-40 border-b bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/55 md:hidden">
        <div className="mx-auto flex h-14 max-w-md items-center justify-between px-4">
          <div className="font-display text-lg font-semibold tracking-tight">{title}</div>
          <Button asChild variant="outline" size="sm" className="rounded-full">
            <Link to="/numeroloji">Numeroloji</Link>
          </Button>
        </div>
      </header>

      <main
        className={cn(
          "mx-auto w-full max-w-md px-4 pb-24 pt-4",
          "sm:max-w-2xl sm:px-6",
          "lg:max-w-6xl",
          "md:pb-10",
          pathname.startsWith("/karma/u/") ? "pt-4" : "",
        )}
      >
        <Outlet />
      </main>

      <BottomTabBar className="md:hidden" />
    </div>
  );
}
